import { api } from "../configs/axiosConfigs";

const PartnerJoinApi = {
  getJoinPage: async (referralCode) => {
    const encoded = encodeURIComponent(referralCode || "");
    const response = await api.request({
      url: `/api/partner/join/${encoded}`,
      method: "GET",
    });
    return response.data;
  },

  submitJoin: async (payload) => {
    const response = await api.request({
      url: "/api/partner/join",
      method: "POST",
      data: payload,
    });
    return response.data;
  },
};

export default PartnerJoinApi;
